export const TOOL_KEY_SHORTCUT = {
    Bold: 'b',
    Italic: 'i',
    Strikethrough: 's',
};
